export { default } from '@shikijs/langs/make'
